/* SS_MULTILINGUAL_FIXES_20260515_START */
(function () {
  if (window.__ssMultilingualFixes20260515) return;
  window.__ssMultilingualFixes20260515 = true;

  var supportedLanguages = ['fr', 'nl', 'it'];

  function compactText(value) {
    var text = String(value || '');
    text = text.split(String.fromCharCode(9)).join(' ');
    text = text.split(String.fromCharCode(10)).join(' ');
    text = text.split(String.fromCharCode(13)).join(' ');
    text = text.split(String.fromCharCode(12)).join(' ');
    while (text.indexOf('  ') !== -1) {
      text = text.split('  ').join(' ');
    }
    return text.trim();
  }

  function getStorefrontLanguage() {
    var pathLanguage = (window.location.pathname.split('/')[1] || '').toLowerCase();
    if (supportedLanguages.indexOf(pathLanguage) !== -1) return pathLanguage;

    var htmlLanguage = (document.documentElement.getAttribute('lang') || '')
      .toLowerCase()
      .split('-')[0];
    if (supportedLanguages.indexOf(htmlLanguage) !== -1) return htmlLanguage;

    return '';
  }

  function withCheckoutLocale(url) {
    var language = getStorefrontLanguage();
    if (!language) return url;

    try {
      var checkoutUrl = new URL(url, window.location.origin);
      if (checkoutUrl.pathname === '/cart') {
        checkoutUrl.pathname = '/' + language + '/cart';
      }
      checkoutUrl.searchParams.set('locale', language);
      return checkoutUrl.pathname + checkoutUrl.search + checkoutUrl.hash;
    } catch (error) {
      var separator = url.indexOf('?') === -1 ? '?' : '&';
      return url + separator + 'locale=' + encodeURIComponent(language);
    }
  }

  function localizedCheckoutUrl() {
    var language = getStorefrontLanguage();
    return language
      ? '/' + language + '/cart?checkout&locale=' + encodeURIComponent(language)
      : '/cart?checkout';
  }

  function submitLocalizedCheckout() {
    var language = getStorefrontLanguage();
    if (!language) {
      window.location.href = localizedCheckoutUrl();
      return;
    }

    var form = document.createElement('form');
    form.method = 'post';
    form.action = '/' + language + '/cart?locale=' + encodeURIComponent(language);

    var checkoutInput = document.createElement('input');
    checkoutInput.type = 'hidden';
    checkoutInput.name = 'checkout';
    checkoutInput.value = 'Checkout';
    form.appendChild(checkoutInput);

    var localeInput = document.createElement('input');
    localeInput.type = 'hidden';
    localeInput.name = 'locale';
    localeInput.value = language;
    form.appendChild(localeInput);

    document.body.appendChild(form);
    form.submit();
  }

  function textContainsAny(text, needles) {
    for (var i = 0; i < needles.length; i += 1) {
      if (text.indexOf(needles[i]) !== -1) return true;
    }
    return false;
  }

  function isCheckoutTrigger(element) {
    if (!element) return false;

    var text = compactText(
      element.innerText || element.value || element.getAttribute('aria-label')
    ).toLowerCase();
    var href = element.getAttribute('href') || '';
    var name = (element.getAttribute('name') || '').toLowerCase();
    var className = element.className && element.className.toString
      ? element.className.toString()
      : '';

    if (className.indexOf('qsc2-checkout-button') !== -1) return true;
    if (name === 'checkout') return true;
    if (
      href.indexOf('/checkout') !== -1 ||
      href.indexOf('/checkouts') !== -1 ||
      href.indexOf('checkout') !== -1
    ) {
      return true;
    }

    return textContainsAny(text, [
      'paiement securise',
      'paiement sécurisé',
      'vai al pagamento',
      'afrekenen',
      'checkout',
      'zur kasse',
      'sicher bezahlen'
    ]);
  }

  function ensureCartFormsUseLocale() {
    var language = getStorefrontLanguage();
    if (!language) return;

    document.querySelectorAll('form[action*="/cart"]').forEach(function (form) {
      try {
        var actionUrl = new URL(form.getAttribute('action') || '/cart', window.location.origin);
        if (actionUrl.pathname === '/cart') {
          actionUrl.pathname = '/' + language + '/cart';
        }
        actionUrl.searchParams.set('locale', language);
        form.setAttribute('action', actionUrl.pathname + actionUrl.search + actionUrl.hash);
      } catch (error) {}

      var input = form.querySelector('input[name="locale"]');
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'locale';
        form.appendChild(input);
      }
      input.value = language;
    });

    document
      .querySelectorAll(
        'a[href*="/checkout"], a[href*="/checkouts"], a[href*="/cart?checkout"], a[href*="/cart?view=checkout"]'
      )
      .forEach(function (link) {
        link.setAttribute('href', withCheckoutLocale(link.getAttribute('href')));
      });
  }

  document.addEventListener(
    'click',
    function (event) {
      var trigger = event.target && event.target.closest
        ? event.target.closest('a, button, input[type="submit"]')
        : null;
      if (!trigger || !isCheckoutTrigger(trigger)) return;

      var language = getStorefrontLanguage();
      if (!language) return;

      if (trigger.getAttribute('name') === 'checkout' && trigger.closest && trigger.closest('form')) {
        ensureCartFormsUseLocale();
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();
      submitLocalizedCheckout();
    },
    true
  );

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || !form.matches || !form.matches('form[action*="/cart"]')) return;
      ensureCartFormsUseLocale();
    },
    true
  );

  function translatedGalleryUrl(trigger) {
    var href = trigger.href || trigger.getAttribute('href') || '';
    var image = trigger.querySelector('img');
    var imageSrc = image && (image.currentSrc || image.src);
    if (!imageSrc) return href;

    try {
      var hrefUrl = new URL(href, window.location.href);
      var imageUrl = new URL(imageSrc, window.location.href);
      if (hrefUrl.pathname !== imageUrl.pathname) return imageUrl.href;
      return hrefUrl.href;
    } catch (error) {
      return imageSrc || href;
    }
  }

  function openTranslatedLightbox(index) {
    var triggers = Array.prototype.slice.call(document.querySelectorAll('.lightbox-trigger'));
    var modal = document.getElementById('lightbox-modal');
    var lightboxImage = document.getElementById('lightbox-img');
    if (!modal || !lightboxImage || !triggers.length) return false;

    var normalizedIndex = (index + triggers.length) % triggers.length;
    modal.dataset.ssCurrentIndex = String(normalizedIndex);
    lightboxImage.src = translatedGalleryUrl(triggers[normalizedIndex]);
    modal.style.display = 'flex';
    return true;
  }

  document.addEventListener(
    'click',
    function (event) {
      if (window.innerWidth < 1024) return;

      var trigger = event.target && event.target.closest
        ? event.target.closest('.lightbox-trigger')
        : null;
      if (!trigger) return;

      var triggers = Array.prototype.slice.call(document.querySelectorAll('.lightbox-trigger'));
      var index = triggers.indexOf(trigger);
      if (index < 0) return;

      if (openTranslatedLightbox(index)) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    },
    true
  );

  document.addEventListener(
    'click',
    function (event) {
      if (window.innerWidth < 1024) return;

      var previous = event.target && event.target.closest
        ? event.target.closest('.lightbox-prev')
        : null;
      var next = event.target && event.target.closest
        ? event.target.closest('.lightbox-next')
        : null;
      if (!previous && !next) return;

      var modal = document.getElementById('lightbox-modal');
      if (!modal || modal.style.display !== 'flex') return;

      var currentIndex = parseInt(modal.dataset.ssCurrentIndex || '0', 10) || 0;
      var nextIndex = previous ? currentIndex - 1 : currentIndex + 1;

      if (openTranslatedLightbox(nextIndex)) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    },
    true
  );

  var cookieTranslations = {
    fr: {
      content:
        'Nous utilisons des cookies pour assurer le bon fonctionnement du site et vous offrir la meilleure expérience. Vous choisissez ceux que vous acceptez. Plus d’informations dans notre %{cookie_policy_link}. Cordialement - Studio Sonntag',
      accept: 'Tout accepter',
      reject: 'Tout refuser',
      customize: 'En savoir plus et personnaliser',
      policy: 'politique de confidentialité'
    },
    nl: {
      content:
        'Wij gebruiken cookies om de website goed te laten werken en je de beste ervaring te bieden. Jij bepaalt welke cookies je accepteert. Meer informatie vind je in ons %{cookie_policy_link}. Hartelijke groeten - Studio Sonntag',
      accept: 'Alles accepteren',
      reject: 'Alles weigeren',
      customize: 'Meer informatie en aanpassen',
      policy: 'privacybeleid'
    },
    it: {
      content:
        'Usiamo i cookie per far funzionare correttamente il sito e offrirti la migliore esperienza. Puoi scegliere quali cookie accettare. Trovi maggiori informazioni nella nostra %{cookie_policy_link}. Cordiali saluti - Studio Sonntag',
      accept: 'Accetta tutto',
      reject: 'Rifiuta tutto',
      customize: 'Scopri di più e personalizza',
      policy: 'informativa sulla privacy'
    }
  };

  function configureCookieBanner() {
    var language = getStorefrontLanguage();
    var translation = cookieTranslations[language];
    if (!translation) return;

    if (window._iub && window._iub.csConfiguration) {
      window._iub.csConfiguration.lang = language;
      window._iub.csConfiguration.banner = window._iub.csConfiguration.banner || {};
      window._iub.csConfiguration.banner.content = translation.content;
      window._iub.csConfiguration.banner.acceptButtonCaption = translation.accept;
      window._iub.csConfiguration.banner.rejectButtonCaption = translation.reject;
      window._iub.csConfiguration.banner.customizeButtonCaption = translation.customize;
      window._iub.csConfiguration.banner.cookiePolicyLinkCaption = translation.policy;
    }
  }

  function translateCookieBannerDom() {
    var language = getStorefrontLanguage();
    var translation = cookieTranslations[language];
    var banner = document.getElementById('iubenda-cs-banner');
    if (!translation || !banner) return;

    var link = banner.querySelector('.iubenda-cs-cookie-policy-lnk');
    if (link && link.textContent !== translation.policy) {
      link.textContent = translation.policy;
    }

    var paragraph = banner.querySelector(
      '#iubenda-cs-paragraph, .iubenda-cs-rationale p, .iubenda-cs-content p'
    );
    if (paragraph) {
      var linkHtml = link ? link.outerHTML : translation.policy;
      var paragraphHtml = translation.content.split('%{cookie_policy_link}').join(linkHtml);
      if (paragraph.innerHTML !== paragraphHtml) {
        paragraph.innerHTML = paragraphHtml;
      }
    }

    var accept = banner.querySelector('.iubenda-cs-accept-btn');
    var reject = banner.querySelector('.iubenda-cs-reject-btn');
    var customize = banner.querySelector('.iubenda-cs-customize-btn');
    if (accept && accept.textContent !== translation.accept) {
      accept.textContent = translation.accept;
    }
    if (reject && reject.textContent !== translation.reject) {
      reject.textContent = translation.reject;
    }
    if (customize && customize.textContent !== translation.customize) {
      customize.textContent = translation.customize;
    }
  }

  window.addEventListener('iub::configurationIsSet', configureCookieBanner, true);

  var observer = new MutationObserver(function () {
    translateCookieBannerDom();
    ensureCartFormsUseLocale();
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('DOMContentLoaded', function () {
    configureCookieBanner();
    translateCookieBannerDom();
    ensureCartFormsUseLocale();
  });

  configureCookieBanner();
  setInterval(function () {
    translateCookieBannerDom();
    ensureCartFormsUseLocale();
  }, 1500);
})();
/* SS_MULTILINGUAL_FIXES_20260515_END */
